$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
TrelloEmoji = require 'app/scripts/views/emoji/trello-emoji'
l = require 'app/scripts/lib/localize'
ModelCache = require 'app/scripts/db/model-cache'
ModelCacheListener = require 'app/scripts/views/internal/model-cache-listener'
PopOver = require 'app/scripts/views/lib/pop-over'
t = require('app/scripts/views/internal/recup-with-helpers')('reactions')
{ trackUe } = require '@trello/analytics'
Tooltip = require 'app/scripts/views/lib/tooltip'
TrelloEmoji = require 'app/scripts/views/emoji/trello-emoji'
React = require 'react'
ReactDOM = require 'react-dom'
ReactionIcon = require 'app/scripts/views/reactions/reaction-icon'
ReactionSelector = require 'app/scripts/views/reactions/reaction-selector'
ReactionTooltip = require 'app/scripts/views/reactions/reaction-tooltip'
View = require 'app/scripts/views/internal/view'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'

# Lazily create a ‘heart’ emoji HTML string to inject into the reaction limits
# message. Result is memoized.
getHeartHtml = _.once ->
  heartContainer = $('<div></div>')
  ReactDOM.render(React.createElement(TrelloEmoji, {
    emoji: 'heart_decoration',
    size: 11
  }), heartContainer[0])
  heartHtml = heartContainer.html()
  ReactDOM.unmountComponentAtNode(heartContainer[0])
  heartContainer.remove()
  return heartHtml

class ReactionPiles extends React.Component
  displayName: 'ReactionPiles'

  constructor: (props) ->
    super(props)
    @state =
      reactionSelectorOpen: false
      reactionList: @props.reactionList

    @_listen()

  _listen: ->
    @_alertEvent 'uniqueReactionLimit', 'unique-reaction-limit-exceeded'
    @_alertEvent 'totalReactionLimit', 'total-reaction-limit-exceeded'
    @_alertEvent 'addReactionError', 'add-reaction-error'
    @_alertEvent 'removeReactionError', 'remove-reaction-error'

    @props.modelListener @props.reactionList, 'add remove reset', =>
      @props.onReactionChanged && @props.onReactionChanged()
      @setState { reactionList: @props.reactionList }

    @props.modelListener @props.reactionList, 'add remove reset', =>
      @setState { reactionList: @props.reactionList }

  _alertEvent: (eventName, message) ->
    @props.modelListener @props.reactionList, eventName, (limit) =>
      html = if limit
        t.l(message, {
          number: limit?.disableAt,
          heart: getHeartHtml()
        }, { raw: true })
      else
        t.l message

      Alerts.showHtml(
        html
        'error'
        'alert'
        3000
      )

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    { category } = @props.trackingContext
    actionData = JSON.stringify _.omit(@props.trackingContext, 'category')

    trackUe(category, verb, dirObj, prepObj, indObj, method, actionData)

  toggleReaction: (emoji, e) =>
    Util.stop(e)

    if !@props.canReact
      return

    trackFn = (isAdded) =>
      method =
        'by clicking the pile'
      @trackWithData(
        if isAdded then 'adds' else 'removes',
        'reaction',
        emoji.id,
        if isAdded then 'to a comment' else 'from a comment',
        method,
      )

    @props.reactionList.toggleReaction(@props.actionId, emoji, trackFn)

  showReactionTooltip: (emoji, e) =>
    $btn = $(e.currentTarget)
    reaction = emoji.colons

    currentUserReacted = false
    # Get all the reactions for the current hover
    names =
      @props.reactionList.chain()
      .filter (model) -> model.toEmojiMart().colons == reaction
      .omit (reaction) ->
        isCurrentUser = reaction.get('idMember') == Auth.myId()
        if isCurrentUser
          currentUserReacted = true
        isCurrentUser
      .map (reaction) => ModelCache.get('Member', reaction.get('idMember'))?.get 'fullName'
      .compact()
      .value()

    if currentUserReacted
      names = [l('You'), names...]

    tooltipHtml = new ReactionTooltip { names, reaction }

    Tooltip.show(tooltipHtml, $btn, false, Tooltip.STYLE.MENU)

  hideReactionTooltip: ->
    Tooltip.hide()

  mapReactionListToPiles: ->
    @props.reactionList.chain()
      .groupBy (reaction) -> reaction.toEmojiMart().colons
      .pairs()
      .map ([emoji, entries]) ->
        return {
          reaction: emoji
          count: entries.length
          mine: _.any(entries, (reaction) -> reaction.get('idMember') == Auth.myId())
        }
      .value()

  handleEmojiClick: (emoji, e) =>
    @hideReactionTooltip()
    @toggleReaction(emoji, e)
    @props.onEmojiClick && @props.onEmojiClick(emoji, e)

  handleEmojiOver: (emoji, e) =>
    @showReactionTooltip(emoji, e)
    @props.onEmojiOver && @props.onEmojiOver(emoji, e)

  openReactionSelector: (e) =>
    @shouldSuppressTracking = false
    $currentTarget = $(e.currentTarget)
    Util.stop(e)

    @setState { reactionSelectorOpen: true }

    method = "by clicking the picker button #{
      if $currentTarget.parents('.inline-add-reaction').length > 0
        'inline'
      else
        'next to reactions'
    }"

    if @state.reactionSelectorOpen
      @shouldSuppressTracking = true
      PopOver.popView()
      @setState { reactionSelectorOpen: false }
      @trackWithData 'closes', 'reaction selector', '', '', method
      return

    @trackWithData 'opens', 'reaction selector', '', '', method

    reactionSelectorSettings = {
      actionId: @props.actionId,
      reactionList: @props.reactionList,
      trackingContext: @props.trackingContext,
      onReactionClick: (e, emoji) =>
        Util.stop(e)
        @shouldSuppressTracking = true
        @setState { reactionSelectorOpen: false }
        PopOver.popView()
    }

    PopOver.show
      elem: $(e.currentTarget)
      hideHeader: true
      displayType: 'mod-reaction-selector'
      view: new ReactionSelector reactionSelectorSettings
      showImmediately: true
      hidden: =>
        _.defer =>
          @setState { reactionSelectorOpen: false }
          if !@shouldSuppressTracking
            @trackWithData 'closes', 'reaction selector', '', '', 'by clicking outside'

  renderReactIcon: ->
    t.div '.reaction-pile-selector', =>
      t.createElement ReactionIcon, {
        disabled: !@props.canReact
        withBorder: true
        onClick: @openReactionSelector
        active: @state.reactionSelectorOpen
      }

  renderInlineReactIcon: =>
    t.span '.inline-add-reaction.meta-add-reaction.quiet', =>
      t.createElement ReactionIcon, {
        disabled: !@props.canReact
        withBorder: false
        onClick: @openReactionSelector
        active: @state.reactionSelectorOpen
      }

  render: t.renderable ->
    {
      canReact,
      onEmojiClick,
      onEmojiOver,
      renderReactIconWithBorder
    } = @props

    reactionPiles = @mapReactionListToPiles()

    t.div '.reaction-piles', { class: t.classify({
      'reaction-piles-empty': !reactionPiles.length,
      'disabled': !canReact
    }) }, =>
      for { reaction, count, mine } in reactionPiles
        t.div '.reaction-pile-item', { class: t.classify('my-reaction': mine), 'data-reaction': reaction }, =>
          t.addElement React.createElement TrelloEmoji, {
            emoji: reaction
            onClick: @handleEmojiClick
            onOver: @handleEmojiOver
            onLeave: @hideReactionTooltip
          }
          t.span '.reaction-pile-count', ->
            count = if count > 99 then '99+' else count
            t.text count
      if reactionPiles.length || renderReactIconWithBorder
        @renderReactIcon()
      else
        @renderInlineReactIcon()

module.exports = ModelCacheListener(ReactionPiles)
